import request from 'xhr'

var vks = {
  URLS: {
    disco: 'https://viakeyscreen.com/disco/',
    version: '/version/',
    legacy: '/migrate/uri',
    items: function (id) {
      return '/media/' + id + '/items'
    },
    relatedMovies: function (id) {
      return '/media/' + id + '/related'
    },
    media: '/media/',
    schedule: '/feed/schedule/',
    feed: '/feed/all/',
    trending: '/feed/trending/',
    search: '/search/',
    babel: '/search/babel',
    video: '/xchg/video/',
    stream: '/hls/master/',
    track: '/track',
    autocomplete: '/search/autocomplete',
    related: '/search/related/',
    asset: '/asset/',
    match: '/media/match/',
    contact: '/contact',
    subscribe: '/subscribe/',
    activity: function (id) {
      return '/profile/' + id + '/activity/'
    },
    update: function (id) {
      return '/profile/' + id + '/update/'
    },
    token: '/profile/token/sms',
    voucher: '/payment/voucher',
    campaign: function (id, name) {
      return '/campaign/media/' + id + '/' + name
    },
    profile: function(id) {
      return {
        get: function() {
          return '/profile/' + id
        },
        update: function() {
          return '/profile/' + id + '/update/'
        }
      }
    }
  },
  HEADERS: {},
  VERSION: process.env.NODE_ENV === 'production' ? 'vks2' : 'beta'
}

vks.parseUriParams = function (params) {
  var param = ''
  var p

  if (params) {
    param = '?'
    for (p in params) {
      if (params.hasOwnProperty(p)) {
        param += p
        param += '='
        if (params[p] && typeof params[p] === 'object' && params[p].constructor === Object) {
          params[p] = JSON.stringify(params[p])
        }
        param += params[p]
        param += '&'
      }
    }
    param = param.slice(0, -1)
  }

  return param
}

vks.format = {
  item: function (res) {
    return new Promise((resolve, reject) => {
      if (res.length) {
        resolve(res[0])
      } else {
        reject(res)
      }
    })
  },

  legacy: function (res) {
    return new Promise((resolve, reject) => {
      if (res.rows && res.rows.length) {
        resolve(res.rows[0])
      } else {
        reject(res)
      }
    })
  },

  media: function (res) {
    return new Promise((resolve, reject) => {
      if (res.rows && res.rows.length) {
        resolve(res.rows[0].doc)
      } else {
        reject(res)
      }
    })
  },

  rows: function (res) {
    return new Promise((resolve, reject) => {
      // null data removed temporarily
      if (res.rows && res.rows.length) {
        resolve(res.rows)
      } else {
        reject(res)
      }
    })
  },

  data: function (res) {
    return new Promise((resolve, reject) => {
      if (res) {
        resolve(res)
      } else {
        reject(res)
      }
    })
  }
}

vks.init = function (domain, outlet, version, opts) {

  vks.HEADERS['x-vks-outlet'] = outlet
  vks.HEADERS['x-vks-language'] = 'arabic' // TBD

  if (opts) {
    if (opts.language) {
      vks.HEADERS['x-vks-language'] = opts.language
    }

    if (opts.debug) {
      vks.HEADERS['x-vks-debug'] = opts.debug
    }

    if (opts.preview) {
      vks.HEADERS['x-vks-preview'] = opts.preview
        if (opts.preview_id) {
          vks.HEADERS['x-vks-preview-id'] = opts.preview_id
        }
    }
  }

  return new Promise((resolve, reject) => {
    var checkVersion
    var getBase
    var baseUrl = process.env.NODE_ENV === 'production'
      ? 'https://viakeyscreen.com/domain/' + domain
      : 'https://beta.viakeyscreen.com/domain/' + domain

    checkVersion = function (retry) {
      let versionOpts
      let versionCb

      if (!vks.URLS.base) {
        vks.URLS.base = baseUrl
      }
      versionOpts = {
        method: 'get',
        url: vks.URLS.base + vks.URLS.version + outlet + vks.parseUriParams({'version': version}),
        headers: vks.HEADERS,
        json: true
      }

      versionCb = function (err, res, body) {
        if (retry && (err || res.statusCode < 200 || res.statusCode >= 300)) {
          getBase()
        } else if (err) {
          reject({error: err})
        } else if (res.statusCode < 200 || res.statusCode >= 300) {
          reject(body)
        } else {
          resolve()
        }
      }

      request(versionOpts, versionCb)
    }

    getBase = function () {
      var options
      var callback
      options = {
        method: 'get',
        url: vks.URLS.disco + domain + vks.parseUriParams({'version': vks.VERSION}),
        json: true
      }

      callback = function (err, res, body) {
        if (err) {
          reject({error: err})
        } else if (res.statusCode < 200 || res.statusCode >= 300) {
          reject(body)
        } else {
          vks.URLS.base = body.url
          checkVersion()
        }
      }

      request(options, callback)
    }

    checkVersion(true)
  })
}

vks.req = function (options, params, headers) {

  if (params) {
    options.url += vks.parseUriParams(params)
  }

  options.headers = Object.assign({}, vks.HEADERS, headers)
  options.json = true

  return new Promise((resolve, reject) => {
    request(options, (err, res, body) => {
      if (err || res.statusCode < 200 || res.statusCode > 299) {
        reject(res)
      } else {
        resolve(body)
      }
    })
  })

};

vks.get = function (uri, params, headers) {
  var options = {
    method: 'GET',
    url: vks.URLS.base + uri,
  }

  return vks.req(options, params, headers)
}

vks.post = function (uri, body, params, headers) {
  var options = {
    method: 'POST',
    url: vks.URLS.base + uri,
    body: body
  }


  return vks.req(options, params, headers)
}

vks.request = {
  legacy: function (params) {
    return vks.get(vks.URLS.legacy, params).then(vks.format.legacy)
  },

  items: function (id, params, headers) {
    return vks.get(vks.URLS.items(id), params, headers).then(vks.format.rows)
  },

  relatedMovies: function (id, params) {
    return vks.get(vks.URLS.relatedMovies(id), params).then(vks.format.rows)
  },

  media: function (uri) {
    return vks.get(vks.URLS.media + uri).then(vks.format.media)
  },

  schedule: function (placement, params) {
    return {
      current: function () {
        return vks.get(vks.URLS.schedule + placement, params).then(vks.format.item)
      },
      feed: function () {
        return vks.get(vks.URLS.schedule + placement, params).then(vks.format.data)
      },
      items: function () {
        return vks.get(vks.URLS.schedule + placement, params).then(vks.format.media)
      },
      playlists: function () {
        return vks.get(vks.URLS.schedule + placement, params).then(vks.format.rows)
      }
    }
  },

  trending: function (placement, params) {
    return vks.get(vks.URLS.trending + placement, params).then(vks.format.rows)
  },

  feed: function (name, params) {
    return vks.get(vks.URLS.feed + name, params).then(vks.format.data)
  },

  search: function (index, params) {
    return vks.get(vks.URLS.search + index, params).then(vks.format.data)
  },

  babel: function (query, filters) {
    var buildFilter = ''
    var items
    var params = {
      q: query
    }

    for (items in filters) {
      if (filters.hasOwnProperty(items)) {
        buildFilter += items + ':"' + filters[items] + '" '
      }
    }
    params.filter = buildFilter

    return vks.get(vks.URLS.babel, params).then(vks.format.data)
  },

  video: function (id, player, debug) {
    let headers = {}
    if (player) {
      headers['x-vks-player'] = player
    }
    if (debug) {
      headers['x-vks-debug'] = debug
    }

    return vks.get(vks.URLS.video + id, {}, headers).then(vks.format.data)
  },

  subtitle: function (url) {
    var options = {
      method: 'get',
      url: url
    }
    return vks.req(options)
  },

  autocomplete: function (query, params) {
    if (!params) {
      params = {}
    }
    params.q = query

    return vks.get(vks.URLS.autocomplete, params).then(vks.format.rows)
  },

  channel: function (url, params) {
    return vks.get(vks.URLS.search + url, params).then(vks.format.rows)
  },

  related: function (url, params) {
    return vks.get(vks.URLS.related + url, params).then(vks.format.rows)
  },

  asset: function (url, params) {
    return vks.get(vks.URLS.asset + url, params)
  },

  match: function (id, params) {
    return vks.get(vks.URLS.match + id, params)
  },

  contact: function () {
    return vks.get(vks.URLS.contact)
  },

  form: function (params) {
    let body = {
      name: params.name,
      email: params.mail,
      text: params.msg,
      number: params.captcha
    }
    return vks.post(vks.URLS.contact + '/' + params.token, body)
  },

  subscribe: function (params) {
    let body = {
      email: params.mail,
      subscribed: params.sub
    }
    return vks.post(vks.URLS.subscribe + params.format, body)
  },

  activity: function (profileId, name, mediaId, params) {
    let body = {}
    return vks.post(vks.URLS.activity(profileId) + name + '/' + mediaId, body, params)
  },

  update: function (params, profileId) {
    return vks.post(vks.URLS.update(profileId), params)
  },

  token: function (params) {
    let body = params 
    return vks.post(vks.URLS.token, body)
  },

  voucher: function (params, headers) {
    let body = params
    return vks.post(vks.URLS.voucher, body, {}, headers)
  },

  campaign: function (id, name, params) {
    return vks.get(vks.URLS.campaign(id, name), params).then(vks.format.rows)
  },

  profile_activity: function (profileId, activityName, params) {
    return {
      get: function (mediaId) {
        return vks.get(vks.URLS.activity(profileId) + activityName + '/' + (mediaId || ''), params).then(vks.format.data)
      },
      post: function (mediaId) {
        return vks.post(vks.URLS.activity(profileId) + activityName + '/' + mediaId, {}, params)
      },
      update: function (activityId) {
        return vks.post(vks.URLS.activity(profileId) + activityId, {}, params)
      }
    }
  }
}

vks.track = {
  buffering: function (mediaId, renditionId, position, successCb, errorCb) {
    return new Promise((resolve, reject) => {
      var options
      var callback
      var metrics
      var dimensions

      metrics = {
        msec: {
          n: position
        }
      }

      dimensions = {
        media_id: mediaId,
        rendition_id: renditionId,
        name: 'buffering',
        app: 'player'
      }

      options = {
        method: 'post',
        url: vks.URLS.base + vks.URLS.track,
        headers: {
          'Content-Type': 'application/json'
        },
        body: {
          metrics: metrics,
          dimensions: dimensions
        },
        json: true
      }

      callback = function (err, res, body) {
        if (err) {
          if (errorCb) {
            errorCb()
          }
          reject({error: err})
        } else {
          if (successCb) {
            successCb()
          }
          resolve(body)
        }
      }

      vks.req(options, callback)
    })
  }
}

vks.getBaseUrl = function () {
  return vks.URLS.base
}
vks.getStreamUrl = function (mediaId) {
  return vks.URLS.base + vks.URLS.stream + mediaId
}
vks.getImageUrl = function (id, name) {
  return vks.URLS.base + vks.URLS.asset + id + name
}

vks.setLanguage = function (lang) {
  if (vks.HEADERS['x-vks-language'] && vks.HEADERS['x-vks-language'] !== lang) {
    vks.HEADERS['x-vks-language'] = lang
    return true
  }
  return false
}
vks.getLanguage = function () {
  return vks.HEADERS['x-vks-language']
}

export default vks

console.log('vks-sdk', 'ready')



// WEBPACK FOOTER //
// ./src/sdk/vks-sdk.js